import React from "react";

import HTMLDisplay from "./HTMLDisplay";
import { Box } from "@mui/material";

const SurveyEntry_SectionText = ({ section }) => {
  return (
    <Box
      sx={{
        padding: "5px",
      }}
    >
      <HTMLDisplay html={section.text} />
    </Box>
  );
};

export default SurveyEntry_SectionText;
